/* eslint-disable */

export default {
  GITHUB: 'https://github.com/Constellation-Labs/constellation',
  STARDUST_GITHUB: 'https://github.com/stardustCollective',
  TELEGRAM: 'https://t.me/constellationcommunity',
  TWITTER: 'https://twitter.com/conste11ation',
  YOUTUBE: 'https://www.youtube.com/channel/UChMBV4al3p_iO4bnfzcIzVQ',
  MEDIUM: 'https://medium.com/constellationlabs',
  DISCORD: 'https://discord.gg/9PhXJKeAWC',
  DEVDOCS: 'https://docs.constellationnetwork.io',
  DEVSDISCORD: 'https://discord.gg/9PhXJKeAWC',
  DISCORD_INVITE: 'https://discord.com/invite/9PhXJKeAWC',
  NODESTORE: 'https://nodestore.constellationnetwork.io/',
  MARKETPLACE: 'https://shop.constellationnetwork.io/',
  COIN_GECKO_DAG:
    'https://api.coingecko.com/api/v3/coins/constellation-labs?localization=false&tickers=false',
  COIN_GECKO_LTX:
    'https://api.coingecko.com/api/v3/coins/lattice-token?localization=false&tickers=false',
  STARGAZER_WALLET_CHROME:
    'https://chrome.google.com/webstore/detail/stargazer-wallet/pgiaagfkgcbnmiiolekcfmljdagdhlcm',
  STARGAZER_WALLET_ANDROID:
    'https://play.google.com/store/apps/details?id=com.stargazer&hl=en&gl=US',
  STARGAZER_WALLET_IOS:
    'https://apps.apple.com/us/app/stargazer-wallet/id1612326452',
  KUCOIN: 'https://www.kucoin.com/',
  EXOLIX: 'https://exolix.com/?ref=E1hbVMoEf59L0otO',
  LIQUID: 'https://liquid.com/',
  GATEIO: 'https://gate.io/',
  UPHOLD: 'https://uphold.com',
  MEXC: 'https://www.mexc.com/',
  WEEX: 'https://www.weex.com/',
  LBANK: 'https://lbank.com/',
  OURBIT: 'https://www.ourbit.com/',
  XT: 'https://www.xt.com/en',
  C14: 'https://www.c14.money/',
  LATTICE_SIMPLEX: 'https://lattice.is/swap-buy/buy',
  LATTICE_GATEWAY: 'https://lattice.is',
  LATTICE_SWAP: 'https://lattice.is/swap-buy/swap',
  DEVELOPER_DOCS: 'https://docs.constellationnetwork.io/',
  RUN_A_NODE: 'https://docs.constellationnetwork.io/nodes',
  DATAPRENEUR_ACADEMY: 'http://eepurl.com/h9Evz5',
  HELLO_WORLD: 'https://github.com/StardustCollective/dag4.js',
  PRE_ENROLL: 'http://eepurl.com/h9Evz5',
  HYPERGRAPH_HOUR: 'https://www.youtube.com/embed/jLfufymKRSg',
  MAINNET:
    'https://medium.com/constellationlabs/drumroll-please-constellation-networks-mainnet-2-0-launches-september-28-2022-97245fdba05f',
  FLIGHT_PROGRAM: 'http://eepurl.com/hUWZ3j',
  FLIGHT_PROGRAM_HH: 'https://www.youtube.com/embed/IzGesPGF07c',
  DEVELOPER_DOCS_STARGAZER: 'https://docs.constellationnetwork.io/stargazer',
  DEVELOPER_DOCS_STATE_CHANNEL:
    'https://docs.constellationnetwork.io/metagraphs',
  DEVELOPER_DOCS_NODE: 'https://docs.constellationnetwork.io/validators',
  DEVELOPER_DOCS_SDK: 'https://euclid.is',
  STARDUST_COLLECTIVE: 'https://stardust-collective.org/',
  STARGAZER_WALLET_DEMO_GITHUB:
    'https://github.com/StardustCollective/stargazer-wallet-demos',
  NODESTORE_CONSTELLATION: 'https://nodestore.constellationnetwork.io/',
  OPENSEA: 'https://opensea.io/collection/dortrafficminer',
  DAG_EXPLORER: 'https://dagexplorer.io',
  CORE_CONCEPTS: 'https://docs.constellationnetwork.io/learn',
  GITHUB_TESSELATION: 'https://github.com/Constellation-Labs/tessellation',
  STARGAZER_TUTORIALS_PLAYLIST:
    'https://www.youtube.com/playlist?list=PL1iI5n3l2OKCXMu7qDuutCNSHx2XWIH-j',
  LATTICE_STAKING: 'https://platform.lattice.exchange/softnode-staking',
  LATTICE_GOVERNANCE: 'https://platform.lattice.exchange/governance',
  DISCORD_STARGAZER:
    'https://discord.com/channels/991622562889085010/991758709757845534',
  AFFILIATE_PROGRAM:
    'https://nodestore.goaffpro.com/program-details/commissions',
  AIRTABLE: 'https://airtable.com/shrwknKzSm3MtjUlO',
  WHITEPAPER:
    "https://drive.google.com/file/d/1GgUaC4MyfsS9LH1goWi0aeZFDQeHnhx3/view",
  MAILTO_CONSTELLATION: "mailto:info@constellationnetwork.io",
  MAILTO_HELLO: "mailto:hello@constellationnetwork.io",
  HELIUM: "https://www.helium.com/",
  DOR: "https://www.getdor.com/",
  SYNAPSE: "https://synapse.network/",
  LCX: "https://exchange.lcx.com/trade/DAG_ETH",
  QUANT: "https://www.quant.network/",
  CHAINLINK: "https://chain.link/",
  YIELD_APP:
    "https://elevenews.com/2021/03/20/constellation-network-integrates-yield-app-to-give-users-exposure-to-defi/",
  GRAFANA: "http://grafana.constellationnetwork.io:3000/",
  BLOCKFOLIO: "https://blockfolio.com/",
  DELTA: "https://delta.app/en",
  COMMUNITY_MARKETPLACE: "https://shop.constellationnetwork.io/",
  CRYPTO_NEWS: "https://mailchi.mp/constellationnetwork/cryptodaily",
  SPLUNK: "https://www.splunk.com/",
  KINNAMI:
    'https://constellationnetwork.io/pdf/Constellation_Network_Kinnami_Collaboration.pdf',
  SPACE_ISAC:
    'https://medium.com/constellationlabs/constellation-network-to-infinity-and-beyond-16079ab3573c',
  US_AIRFORCE: 'https://www.af.mil/',
  STEADYNAMIC: 'https://steadynamic.com/',
  AWS: 'https://aws.amazon.com/',
  SOPHINEA: 'https://www.sophinea.io/',
  DCODE: 'https://dcode.co/',
  SBIR: 'https://www.forbes.com/sites/darrynpollock/2019/09/20/usafs-blockchain-interest-shows-technologys-power-to-secure-data/?sh=31ef97547cef',
  GBA: 'https://www.gbaglobal.org/',
  PSU: 'https://www.pdx.edu/business/academics/programs/graduate/business-blockchain',
  UMASS: 'https://www.umassd.edu/',
  ASU: 'https://blockchain.asu.edu/',
  MOUSEBELT: 'https://www.mousebelt.com/',
  IEEE: 'https://blockchain.ieee.org/',
  CGI: 'https://www.cgi.com/',
  HYPERGRAPH_HOUR_PLAYLIST:
    'https://www.youtube.com/playlist?list=PL1iI5n3l2OKCFNt8fbhqK1Vhr0eaZA9j4',
  PARTNERSHIP_OVERVIEW:
    'https://docs.google.com/document/d/1ok-MEGOPMRoARy1gGZ6PKNi3HX-zBLmgaNb3Z3WUI9s/edit',
  YOUTUBE_DOUG: 'https://www.youtube.com/embed/GRSxCUKQUh0',
  LEVER: 'https://jobs.lever.co/constellationnetwork',
  JOBS_PROTOCOL_ENG:
    'https://jobs.lever.co/constellationnetwork/81139baf-0eca-431f-9940-ce08ef4d26a6',
  JOBS_GOV_DIR:
    'https://jobs.lever.co/constellationnetwork/96d50747-4ae9-4937-aef5-fc24cdf10ae4',
  JOBS_GOV_EVANGELIST:
    'https://jobs.lever.co/constellationnetwork/6b5e4c12-e500-4977-9b90-ee097b88e1eb',
  JOBS_DEV_ADVOCATE:
    'https://jobs.lever.co/constellationnetwork/61b02e19-2479-4b17-b2f1-d80768c6ae4c',
  JOBS_FULLSTACK_DEV:
    'https://jobs.lever.co/constellationnetwork/367f505f-e417-4100-a08d-12979f2ded6a',
  JOBS_PROD_MANAGER:
    'https://jobs.lever.co/constellationnetwork/5f186220-b22f-479b-bab9-8aa92199e173',
  JOBS_MAR_COOR:
    'https://jobs.lever.co/constellationnetwork/231d69ce-6feb-4c6a-a424-5eca709bc09c',
  JOBS_MAR_PR:
    'https://jobs.lever.co/constellationnetwork/24425d00-eed8-4406-90c3-2bfbb32faf44',
  JOBS_MAR_STRATEGIC:
    'https://jobs.lever.co/constellationnetwork/2ab60108-e521-43cc-aa4e-9fb271853997',
  EUCLID_SDK: 'https://euclid.is',
  TOKENOMICS:
    'https://docs.constellationnetwork.io/learn/tools-resources/tokenomics-litepaper',
  BUY_DTM_LITE: 'https://nodestore.constellationnetwork.io/products/dtm-1',
  DOR_TRANSACTIONS: 'https://explorer.getdor.com/',
  DAG_CHADS: 'https://dagchads.com/',
  APPLE_PODCAST:
    "https://podcasts.apple.com/us/podcast/constellation-network/id1584493313",
  SPOTIFY_PODCAST: "https://open.spotify.com/show/3oiAoktxdk56dU4X3WNejw",
  GENFINITY: "https://genfinity.io/",
  NEBULA: "https://constellation.nebula-tech.io/",
  XIID: "https://www.xiid.com/",
  SIMBA: "https://simbachain.com/",
  CONSULTING_3IT: "https://www.3itconsulting.com/",
  NDF: "https://www.digifoundry.org/",
  FAI: "https://forwardedge.ai/",
  SNOWFLAKE: "https://www.snowflake.com/",
  IBM: "https://www.ibm.com/",
  PANASONIC: "https://connect.na.panasonic.com/toughbook/",
  CHAMINADE_U: "https://chaminade.edu/",
  DIGITAL_CHAMBER: "https://digitalchamber.org/",
  C14: "https://www.c14.money/",
  BRIDGE_3A_DAO: "https://dag-bridge.3adao.org/",
  ELPACA_STREAK: "https://constellationnetwork.medium.com/introducing-the-el-paca-metagraph-ff2b34586918",
  BRIDGE_DAG: 'https://bridge.constellationnetwork.io',   
  STAKE_DAG: 'https://docs.constellationnetwork.io/network-intro/dag-delegation', 
  PACASWAP: "https://pacaswap.com/",
  FORBES_ARTICLE: 'https://www.forbes.com/sites/darrynpollock/2019/09/20/usafs-blockchain-interest-shows-technologys-power-to-secure-data/?sh=31ef97547cef',
  GOV_BLOCKCHAIN_INTEREST: 'https://gbaglobal.org/',
  NATIONAL_DIGIFOUNDARY: 'https://www.digifoundry.org/',
  EXPONENTIAL_DATA_ARTICLE: 'https://www.prnewswire.com/news-releases/constellation-network-achieves-scalability-security-and-defense-approval-in-executing-us-air-force-phase-ii-blockchain-contract-301821462.html',
  SPACE_ISAC_WEBSITE: 'https://www.spaceisac.org/',
  WHITE_PAPER: "https://docs.constellationnetwork.io/network-intro/white-papers",
  WHAT_IS_DAG: "https://docs.constellationnetwork.io/learn/tools-resources/what-is-dag",
  METAGRAPH_TOOLKIT: "https://docs.constellationnetwork.io/metagraph-development/elements/toolkit",
  METAGRAPH_YOUTUBE: "https://www.youtube.com/playlist?list=PL1iI5n3l2OKB8AaU3-LTnKaJVLU5QAZs3",
  METANOMICS: "https://docs.constellationnetwork.io/network-intro/white-papers/metanomics",
  METAGRAPH_DEVELOPMENT: "https://docs.constellationnetwork.io/metagraph-development",
  COINBASE_IOS: "https://apps.apple.com/us/app/coinbase-wallet-nfts-crypto/id1278383455",
  COINBASE_ANDROID: "https://play.google.com/store/apps/details?id=org.toshi&hl=en-US",
  COINBASE_CHROME: "https://chromewebstore.google.com/detail/coinbase-wallet-extension/hnfanknocfeofbddgcijnmhnfnkdnaad?pli=1",
};
